module.exports = __webpack_public_path__ + "static/media/kit_bipedRobotBasic.063e4d70.png";